import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import { API } from 'api';
import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';

import { apiBasePath, apiName } from 'assets';
import { setKits } from 'store/kits';
import { getMainAccountId } from 'store/account';
import { Kit } from '@repo/types';

const fetchKits = async (mainAccountId: string) => {
  const response: { result: Kit[] } = await API.get(
    apiName,
    `${apiBasePath}/kits`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.HOME,
        domain: DOMAINS.KITS,
        importance: IMPORTANCE.CRITICAL,
      },
      context: {
        mainAccountId,
      },
    },
  );
  return response?.result ?? [];
};
export const getKitsQuery = (mainAccountId: string | null) => ({
  queryKey: ['kits', mainAccountId],
  queryFn: async () => mainAccountId && (await fetchKits(mainAccountId)),
});
const useKits = () => {
  const dispatch = useDispatch();
  const mainAccountId = useSelector(getMainAccountId);
  const kitsQuery = useQuery(getKitsQuery(mainAccountId));

  useEffect(() => {
    if (kitsQuery.isSuccess && kitsQuery.data) {
      dispatch(setKits(kitsQuery.data));
    }
  }, [kitsQuery.isSuccess, kitsQuery.data, dispatch]);

  return kitsQuery;
};

export default useKits;
